import { render } from "./SearchOverlay.vue?vue&type=template&id=2c2f77f3&ts=true"
import script from "./SearchOverlay.vue?vue&type=script&lang=ts"
export * from "./SearchOverlay.vue?vue&type=script&lang=ts"

import "./SearchOverlay.vue?vue&type=style&index=0&id=2c2f77f3&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__